import React, { useState } from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts'
import dataService from '../services/dataService'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import FadeIn from 'react-fade-in'
import { CSVLink } from 'react-csv'
/// Ei ole enää käytössä
const OutdoorSensor = () => {
  const [ datas, setDatas ] = useState(null)
  const [ csvDatas, setCsvDatas ] = useState(null)
  const [ start, setStart ] = useState(new Date())
  const [ end, setEnd ] = useState(new Date())
  const [ message, setMessage ] = useState(null)


  const headers = [
    {
      label: 'Date', key: 'Date'
    },
    {
      label: 'Time', key: 'Time'
    },
    {
      label: 'Humidity', key: 'Humidity'
    },
    {
      label: 'Temperature', key:'Temperature'
    }
  ]

  const format = (tickItem) => {
    const dt = new Date(tickItem)
    const m = dt.toLocaleString('default', { month: 'long' })
    const d = dt.getDate()
    const formatDate ='      ' + m.substr(0,3) + '/' + d + '       '
    return formatDate
  }

  const formatLabel = (tickItem) => {
    const dt = new Date(tickItem).toLocaleString('fi-FI')
    return dt
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (start !== null && end !== null) {
      const formatStart = start.getTime()
      const formatEnd = end.getTime()
      console.log('Body schema: ', formatStart, formatEnd)

      try {
        setMessage('Searching database..')

        const data = await dataService.getOutdoor({
          formatStart, formatEnd
        })

        const iterData = data.docs

        const iter = iterData.map(m => m.measurements)
        console.log(iter)

        const sortedIteratedData = iter.sort((a, b) => a.Timestamp - b.Timestamp)

        const csvData = sortedIteratedData.map(m => {
          const formatTs = new Date(m.Timestamp)
          const temp = m.Temperature
          const hum = m.Humidity
          const formTemp = temp.toString().replace('.',',')
          const formHum = hum.toString().replace('.',',')
          return {
            Date: new Date(formatTs).toLocaleDateString('fi-FI'),
            Time: new Date(formatTs).toLocaleTimeString('fi-FI'),
            Temperature:formTemp,
            Humidity: formHum
          }
        })

        console.log(csvData)
        setCsvDatas(csvData)
        console.log(sortedIteratedData)
        setDatas(sortedIteratedData)
        setMessage(null)
      } catch (exception) {
        console.log('Error happened with async req')
      }
    }
  }
  const handleClear = () => {
    setMessage(null)
    setDatas(null)
    setStart(null)
    setEnd(null)
  }

  const GraphDisplay = () => {

    return (
      <div>
        <CSVLink data={csvDatas} headers={headers}>Export as CSV</CSVLink>

        <div className="chart-area">
          <LineChart width={28500} height={500} data={datas} margin={{ top: 5, right: 30, left: 20, bottom: 20, }} >

            <Line type="monotone" name="Humidity %" dataKey="Humidity" stroke="#8884d8" activeDot={{ r: 8 }} />
            <Line type="monotone" name="Temperature °C" dataKey="Temperature" stroke="#82ca9d" />
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="Timestamp" allowDuplicatedCategory={false} tickFormatter={format}/>
            <YAxis />
            <Tooltip labelFormatter={formatLabel} />
          </LineChart>
        </div>
      </div>
    )}

  const DefaultView = () => {
    return (
      <div>
        <p>{message}</p>
        <div className="info">Give dates as inputs</div>
      </div>
    )
  }

  return (
    <div>
      <FadeIn transitionDuration="1000">
        <div className="calendar">
          <h2>Outdoor Sensor</h2>
          <form onSubmit={handleSubmit}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <label>From:</label>
                  </td>
                  <td>
                    <DatePicker autoComplete="off" selected={start} name="Start" value={start} onChange={date => setStart(date)}  dateFormat="dd.MM.yyyy" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>To:</label>
                  </td>
                  <td>
                    <DatePicker autoComplete="off" selected={end} name="End" value={end} onChange={date => setEnd(date)}  dateFormat="dd.MM.yyyy" />
                  </td>
                </tr>
              </tbody>
            </table>
            <button className="searchBtn" type="submit">Search</button>
            <button className="clearBtn" onClick={handleClear}>Clear</button>
          </form>
        </div>

        {
          datas === null ?
            DefaultView() :
            GraphDisplay()
        }
      </FadeIn>
    </div>
  )
}


export default OutdoorSensor